// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

import { useExtraWorkedTimeRequests } from "@src/appV2/ExtraWorkedTimeRequests/api/useExtraWorkedTimeRequests";
import {
  ExtraWorkedTimeRequestPayer,
  ExtraWorkedTimeRequestStatus,
  ExtraWorkedTimeType,
} from "@src/appV2/ExtraWorkedTimeRequests/types";
import { SessionType } from "@src/modules/interface";

export function usePendingExtraWorkedTimeRequestCount(): number {
  const { profile } = useSelector((state: SessionType) => state.session);

  const { data } = useExtraWorkedTimeRequests(
    {
      filter: {
        type: [ExtraWorkedTimeType.BREAK, ExtraWorkedTimeType.FULL_SHIFT],
        status: [ExtraWorkedTimeRequestStatus.PENDING],
        facilityId: profile ? [profile.userId] : undefined,
        billedTo: [ExtraWorkedTimeRequestPayer.HCF],
      },
      page: {
        size: 0,
      },
    },
    {
      enabled: Boolean(profile?.userId),
    }
  );

  return data?.meta.count ?? 0;
}
